<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增商品投放</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            :group="group"
            group-select
            @input-group-option="inputGroupOption"
        ></app-base-info>
        <app-product-target-picker
            ref="picker"
            :market-id="marketId"
            :form="form.productTargetPickerForm"
            bid-input
            :ad-product$="adProduct$"
            title="商品投放"
            bidLabelWidth="110px"
        ></app-product-target-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";
  import AppBaseInfo from "../common/base-info";
  import AppProductTargetPicker from "../common/product-target-picker";
  import {AdGroupEnum} from "../../../../../common/enum";
  import {defaultVal, isMeaningful} from "../../../../../../../../utils/common";
  import {addSdAdProductTarget, getSdAdProductPage} from "../../../../../../../../api/ad";

  export default {
    name: "app-add-sd-ad-product-target",
    mixins: [modalMixIn],
    components: {AppProductTargetPicker, AppBaseInfo},
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
            campaignId: null,
            groupId: null,
          },
          productTargetPickerForm: {
            items: [],
            bid: null
          }
        },
        adProduct$: null,
      }
    },
    watch: {
      group: {
        handler: function(group) {
          if (isMeaningful(group)) {
            this.$nextTick(() => {
              this.inputGroupOption({
                id: group.groupId,
                bid: group.bid
              });
            });
          }
        },
        immediate: true
      }
    },
    methods: {
      inputGroupOption(option) {
        if (isMeaningful(option)) {
          this.adProduct$ = getSdAdProductPage({
            model: {
              marketId: this.marketId,
              campaignId: this.form.baseInfoForm.campaignId,
              groupId: option.id,
            },
            current: 1,
            size: 99999
          });
          this.form.productTargetPickerForm.bid = option.bid;
        }
      },
      confirm() {
        const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
        if (formValid) {
          const params = {
            marketId: this.marketId,
            campaignId: this.form.baseInfoForm.campaignId,
            campaignName: this.form.baseInfoForm.campaignName,
            targetingType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
            groupId: this.form.baseInfoForm.groupId,
            groupName: this.form.baseInfoForm.groupName,
            adsManualTargetingParamList: this.form.productTargetPickerForm.items.map(item => {
              const productTargetParams = {
                bid: item.bid
              };
              productTargetParams.id = defaultVal(item.categoryId, null);
              productTargetParams.asin = defaultVal(item.asin, null);
              productTargetParams.brandId = defaultVal(item.brandId, null);
              productTargetParams.lowPrice = defaultVal(item.lowPrice, null);
              productTargetParams.maxPrice = defaultVal(item.maxPrice, null);
              productTargetParams.marks = defaultVal(item.marks, null);
              productTargetParams.prime = defaultVal(item.prime, null);

              return productTargetParams;
            })
          };
          this.confirmLoading = true;
          addSdAdProductTarget(params)
            .then(() => {
              this.$emit('created');
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
